import { Environment } from "./env.data";

declare const NG_CONFIG: {[key: string]: any};

const dev_environment: Environment = {
    production: false,
    useEmulator: false,
    firebase: {
        apiKey: 'AIzaSyDxDLlQD8E9ZecWP_H6JLJ1soVPGterS8o',
        authDomain: 'dev.joi.events',
        databaseURL: 'https://joi-events-dev.firebaseio.com',
        projectId: 'joi-events-dev',
        storageBucket: 'joi-events-dev.appspot.com',
        messagingSenderId: '819863447066',
        appId: "1:819863447066:web:c720915507b2a395",
        // measurementId: "G-Y7Y21SY7KF"
    },
    // apiEndpoint: 'https://staging.site.com/api',
    ...(typeof NG_CONFIG === 'undefined' ? {} : NG_CONFIG),
    functionsURL: 'https://us-central1-joi-events-dev.cloudfunctions.net/',
    serverGoogleApiKey: 'AIzaSyA_sSQISKwVna667jlEf3ABtlpz9YLARtQ',
    stripePubKey: 'pk_test_fZmrpDN99oa6dkJv3Uh5l5Ls00iQI7zMmI',
    recaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    HubspotApi: 'https://api.hubapi.com/',
    hsPortalId: '5389409',
    hsSignupFormGUID: 'df9f2217-0089-4dc6-b00b-46cb2a1ebc2b',
    hsProfileFormGUID: 'adeb716f-d666-4dae-a1fa-207d4af64a5e',
    joi: {
      shareBase: 'https://dev.joi.land/',
      appBase: 'https://dev.joi.events/'
    },
    flutterLoadingTime: 50,
    MAX_PAGE_SIZE: 420000 / 10
};

export const environment = dev_environment;
